'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _util = require('../../../util');

var _util2 = _interopRequireDefault(_util);

var _multiSelectDropdown = require('./multi-select-dropdown');

var _multiSelectDropdown2 = _interopRequireDefault(_multiSelectDropdown);

var _trigger = require('../../../trigger');

var _trigger2 = _interopRequireDefault(_trigger);

var _icon = require('../../../icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var MultiSelect = function (_M$BaseComponent) {
  _inherits(MultiSelect, _M$BaseComponent);

  function MultiSelect(props) {
    _classCallCheck(this, MultiSelect);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(MultiSelect).call(this, props));

    Object.assign(_this.state, {
      value: [],
      showDropdown: false
    });
    return _this;
  }

  _createClass(MultiSelect, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.windowEventListener('click', function (e) {
        if (!_this2.state.showDropdown) {
          return;
        }
        var _refs = _this2.refs;
        var $container = _refs.container;
        var trigger = _refs.trigger;

        var $trigger = trigger && trigger.getPopupDOMNode();
        if ($container && !$container.contains(e.target) && (!$trigger || !$trigger.contains(e.target))) {
          _this2._toggleDropdown(false);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        value: nextProps.value && nextProps.value.slice() || []
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var baseCls = 'derived-multi-select';
      var _state = this.state;
      var showDropdown = _state.showDropdown;
      var value = _state.value;
      var _props = this.props;
      var model = _props.model;
      var getPopupContainer = _props.getPopupContainer;
      var onFetchData = _props.onFetchData;
      var onFetchNodeData = _props.onFetchNodeData;
      var parent = _props.parent;
      var _selectType_ = model._selectType_;
      var conf = model.conf;
      var m = model.model;

      var _ref = conf || {};

      var placeholder = _ref.placeholder;
      var triggerClassName = _ref.triggerClassName;
      var align = _ref.align;
      var className = _ref.className;
      var searchPlaceholder = _ref.searchPlaceholder;

      var otherConf = _objectWithoutProperties(_ref, ['placeholder', 'triggerClassName', 'align', 'className', 'searchPlaceholder']);

      var selectProps = _extends({}, otherConf, {
        onFetchData: onFetchData && onFetchData.bind(null, parent, model.code),
        onFetchNodeData: onFetchNodeData && onFetchNodeData.bind(null, parent, model.code),
        placeholder: searchPlaceholder || placeholder,
        model: m
      });
      return _react2.default.createElement(
        'div',
        { className: this.classNames(baseCls, className, _defineProperty({}, baseCls + '--active', showDropdown)) },
        _react2.default.createElement(
          'div',
          { ref: 'container', className: baseCls + '__inner' },
          _react2.default.createElement(
            'div',
            { className: baseCls + '__show-field',
              onClick: this._toggleDropdown.bind(this, true) },
            _react2.default.createElement(
              'span',
              null,
              placeholder
            ),
            _react2.default.createElement(_icon2.default, { className: baseCls + '__arrow-icon',
              type: 'angle-down' })
          ),
          _react2.default.createElement(
            _trigger2.default,
            { visible: showDropdown,
              className: triggerClassName,
              align: align,
              ref: 'trigger',
              autoDestory: align ? align.autoDestory : true,
              equalTargetWidth: align ? align.equalTargetWidth : false,
              getPopupContainer: getPopupContainer,
              target: this._getRootTarget },
            _react2.default.createElement(_multiSelectDropdown2.default, { selectProps: selectProps,
              type: _selectType_,
              value: value,
              onCancel: this._toggleDropdown.bind(this, false),
              onConfirm: this._onConfirm })
          )
        )
      );
    }
  }, {
    key: '_toggleDropdown',
    value: function _toggleDropdown(on) {
      this.setState({
        showDropdown: on
      });
    }
  }, {
    key: '_getRootTarget',
    value: function _getRootTarget() {
      return (0, _reactDom.findDOMNode)(this.refs.container);
    }
  }, {
    key: '_onConfirm',
    value: function _onConfirm(value) {
      var _this3 = this;

      this.setState({ value: value }, function () {
        var onChange = _this3.props.onChange;

        onChange && onChange(_this3.state.value);
        _this3._toggleDropdown(false);
      });
    }
  }]);

  return MultiSelect;
}(_util2.default.BaseComponent);

exports.default = MultiSelect;